module.exports = __webpack_public_path__ + "static/media/compras_publica.2913ec71.jpeg";